import * as React from "react";
import { XMarkIcon } from "@heroicons/react/16/solid";
import { api } from "../../api";

export function TagDeleter({
  tag_id,
  onDeleteTag,
}: {
  tag_id: number;
  onDeleteTag: (tag_id: number) => void;
}): JSX.Element {
  const handleClick = async (): Promise<void> => {
    const res = await api.put<"/api/tag/:tag_id/delete">(
      `/api/tag/${tag_id}/delete`
    );

    if (api.isErrorToast(res)) {
      return;
    }

    onDeleteTag(tag_id);
  };

  return (
    <button
      onClick={handleClick}
      className="ml-0.5 cursor-pointer rounded-full p-1 text-slate-400 transition-colors hover:bg-slate-500/30 hover:text-slate-600 dark:text-slate-400 dark:hover:bg-slate-500/40 dark:hover:text-slate-200"
    >
      <XMarkIcon className="h-3 w-3" />
    </button>
  );
}
